import * as service from './service';

import { isWechat } from '@/utils/browser';

const services = { ...service };

const state = {};

const mutations = {};

const actions = {
  // 事件
  generateShareLink({ dispatch }, shareData) {
    if (isWechat) {
      dispatch('getWechatShare', shareData);
    } else {
      dispatch('getAlipayShare', shareData);
    }
  },
  // 步骤
  getWechatShare(context, shareData) {
    return services
      .getWechatShare({
        current_url: window.parent.location.href,
      })
      .then((res) => {
        window.parent.wx.config({
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
        });
        window.parent.wx.ready(() => {
          window.parent.wx.updateAppMessageShareData(shareData);
          window.parent.wx.updateTimelineShareData(shareData);
        });
      });
  },
  getAlipayShare(context, shareData) {
    const keys = Object.keys(shareData);
    keys.forEach((key) => {
      const metaElement = window.parent.document.createElement('meta');
      metaElement.name = 'Alipay:' + key;
      metaElement.content = shareData[key];
      window.parent.document.head.appendChild(metaElement);
    });
  },
};

export default {
  namespaced: true,
  services,
  state,
  mutations,
  actions,
};
